import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { GalleryTheme, TenantDto } from '@nusign/picflow-backend-types';
import { IsDarkColorPipe } from '../../../color-picker/is-dark-color.pipe';
import { ButtonDirective } from '../../directives/button.directive';
import { TooltipDirective } from '../../directives/tooltip.directive';
import { SvgComponent } from '../svg/svg.component';

@Component({
  selector: 'app-tenant-logo-and-contacts',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonDirective, TooltipDirective, SvgComponent, IsDarkColorPipe],
  templateUrl: './tenant-logo-and-contacts.component.html',
  styleUrls: ['./tenant-logo-and-contacts.component.scss'],
})
export class TenantLogoAndContactsComponent {
  readonly tenant = input.required<TenantDto>();
  readonly link = input<string[] | string>(undefined);
  readonly small = input<boolean>(undefined);
  readonly theme = input<GalleryTheme>(undefined);

  niceSite = computed(() => {
    const site = this.tenant()?.contacts.site;
    if (!site) return '';
    if (site.split('//').length === 1) return site;
    return site.split('//')[1];
  });

  fixedLinkedin = computed(() => {
    const linkedIn = this.tenant()?.socials.linkedIn;
    if (!linkedIn) return linkedIn;
    // temp, as in the past, these didn't contain the /in/ or /company/ part
    if (linkedIn.startsWith('/in/') || linkedIn.startsWith('/company/')) return linkedIn;
    return `/company/${linkedIn}`;
  });
}
